import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/rh/terceirizados/listar/form_edit'
import Head from '../../../../../components/head'


function EditarTerceirizadosScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Terceirizados - Recursos Humanos" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarTerceirizadosScreen;